import { Container } from "@mantine/core";
import { SimpleFullScreenPageWithAppBarAndTitle } from "components/pages/pages_with_outlet/SimpleFullScreenPageWithAppBarAndTitle";
import { InstrumentsList } from "../instruments/components/InstrumentsList";

export const OSCEPage = () => {
  return (
    <SimpleFullScreenPageWithAppBarAndTitle
      title="Objective Structured Clinical Examination"
      order={4}
    >
      <Container>
        <InstrumentsList />
      </Container>
    </SimpleFullScreenPageWithAppBarAndTitle>
  );
};
